import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "effect/http-api";
import {
  PaginatedResponse,
  PrvTrademarkApplication,
  PrvTrademarksPaginationParams,
  PrvTrademarksSearchParams,
} from "./models.js";

// Endpoints
const getAll = HttpApiEndpoint.get("getAll", "/prv/trademarks", {
  query: PrvTrademarksPaginationParams,
  success: PaginatedResponse(PrvTrademarkApplication),
  error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
});

const find = HttpApiEndpoint.get("find", "/prv/trademarks/find", {
  query: PrvTrademarksSearchParams,
  success: PaginatedResponse(PrvTrademarkApplication),
  error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
});

// Group & API
export const PrvTrademarksGroup = HttpApiGroup.make("prvV3").add(getAll).add(find);

export * from "./models.js";
